export default __webpack_public_path__ + "static/media/banner.e216be85.png";